module.exports = __webpack_public_path__ + "img/3.cec8e5bf.jpg";